const optionalValueMixin = {
  props: {
    defaultValue: {},
    value: {},
  },
  data () {
    return {
      valueInData: this.defaultValue || []
    }
  },
  computed: {
    cValue () {
      return this.value || this.valueInData
    }
  },
  methods: {
    handleInput (val) {
      this.valueInData = val
      this.$emit('input', val)
    }
  }
}

export default optionalValueMixin
export {
  optionalValueMixin
}



// WEBPACK FOOTER //
// ./src/utils/optional-value.js